import React from 'react'
import { isEmpty } from '../../utils/helper'
import IntentPricingPlansFive from '../customPricingPages/intentPricingPlansFive'
import PolaroidCarouselPricing from '../customPricingPages/polaroidCarouselPricing'

const CustomPricingPage = ({ pageData, data }) => {
  const getPage = (key) => {
    if (!key) return

    let pageProps = {
      data: data.data,
    }
    let pageObj = {
      intentPricingPlansFive: <IntentPricingPlansFive {...pageProps} />,
      polaroidCarouselPricingPlans: <PolaroidCarouselPricing {...pageProps} />,
    }

    return pageObj[key]
  }

  return (
    <div className="w-full h-full">
      {!isEmpty(pageData) && !isEmpty(data) ? getPage(data?.template_key) : null}
    </div>
  )
}

export default CustomPricingPage
